<template>
  <CollapsibleRoot v-slot="{ open }" v-model:open="isOpen" :class="ui.root">
    <CollapsibleTrigger :class="ui.trigger">
      <AwIcon name="i-ph-caret-down-fill" :class="[ui.caret, titleClass, 'font-semibold ', !open && ui.caretClosed]" />
      <span :class="[ui.title, titleClass]">{{ title }}</span>
      <span :class="[ui.count, titleClass]">{{ count }}</span>
    </CollapsibleTrigger>
    <CollapsibleContent :class="ui.content">
      <slot></slot>
    </CollapsibleContent>
  </CollapsibleRoot>
</template>

<script setup lang="ts">
import { AwIcon } from "@asap/design";
import { CollapsibleContent, CollapsibleRoot, CollapsibleTrigger } from "radix-vue";

const props = withDefaults(
  defineProps<{
    title: string;
    count: number;
    color?: "red";
  }>(),
  {
    color: undefined,
  }
);

const isOpen = defineModel<boolean>("open", { default: false });

const titleClass = computed(() => (props.color === "red" ? "text-critical-500" : "text-secondary-900"));

const ui = {
  root: "flex flex-col",
  trigger:
    "flex items-center gap-1.5 py-2 px-3 w-full text-left cursor-pointer border-none bg-transparent hover:bg-secondary-50 rounded-md",
  caret: "size-4 shrink-0 transition-transform",
  caretClosed: "-rotate-90",
  title: "text-sm font-medium",
  count: "text-sm font-medium",
  content: "task-accordion-content",
};
</script>

<style scoped>
.task-accordion-content {
  overflow: hidden;
}

.task-accordion-content[data-state="open"] {
  animation: task-accordion-down 200ms ease-out;
}

.task-accordion-content[data-state="closed"] {
  animation: task-accordion-up 200ms ease-out;
}

@keyframes task-accordion-down {
  from {
    height: 0;
  }

  to {
    height: var(--radix-collapsible-content-height);
  }
}

@keyframes task-accordion-up {
  from {
    height: var(--radix-collapsible-content-height);
  }

  to {
    height: 0;
  }
}
</style>
